import React, { useEffect, useRef, useState } from "react"
import { Col, Modal, Row } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import GeneralNeedSectionViewOnly from "../ViewOnly/GeneralNeedSectionViewOnly"
import OccApproachSectionViewOnly from "../ViewOnly/OccApproachSectionViewOnly"
import ContractSectionViewOnly from "../ViewOnly/ContractSectionViewOnly"
import ForecastSectionViewOnly from "../ViewOnly/ForecastSectionViewOnly"
import GovernanceSectionViewOnly from "../ViewOnly/GovernanceSectionViewOnly"
import LookbackSection from "../LookbackSection"
import ResultSection from "../ResultSection"
import NoteDrawer from "../Drawer/NoteDrawer"
import DocumentDrawer from "../Drawer/DocumentDrawer"
import Breadcrumb from "components/Common/Breadcrumb"
import LocationSection from "../LocationSection"

const BusinessCaseReportPDFPage = props => {
  const containerRef = useRef()
  const currentUser = userService.getLoggedInUser()

  const alternativeId = props.match.params.alternativeId

  const [isExporting, setIsExporting] = useState(false)

  const [tabs, setTabs] = useState([])
  const [alternative, setAlternative] = useState(null)
  const [scenario, setScenario] = useState(null)
  const [enterprise, setEnterprise] = useState(null)
  const [entities, setEntities] = useState([])
  const [fieldConfigItems, setFieldConfigItems] = useState([])

  const [systemRetirementsLabel, setSystemRetirementsLabel] = useState("")
  const [governanceBoardLabel, setGovernanceBoardLabel] = useState("")
  const [sbuLabel, setSbuLabel] = useState("")
  const [planningCategoryLabel, setPlanningCategoryLabel] = useState("")
  const [lbrLabel, setLbrLabel] = useState("")
  const [investmentCategoryLabel, setInvestmentCategoryLabel] = useState("")
  const [advancedPlanningLabel, setAdvancedPlanningLabel] = useState("")
  const [ldoLabel, setLdoLabel] = useState("")
  const [planningStageLabel, setPlanningStageLabel] = useState("")
  const [brmLabel, setBrmLabel] = useState("")

  const [governanceOptions, setGovernanceOptions] = useState([])
  const [sponsoringOptions, setSponsoringOptions] = useState([])
  const [priorityOptions, setPriorityOptions] = useState([])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const rawTabs = params.get("tabs")
    debugger
    if (rawTabs) {
      const tabs = JSON.parse(rawTabs)
      setTabs(tabs)
    }

    loadData()
  }, [])

  const loadData = async () => {
    let alt = await api.getAlternative(alternativeId)
    setAlternative(alt)
    loadGeneralDropdownData(alt.scenarioID)
    let sc = await api.getScenario(alt.scenarioID)
    await loadLabels(sc)
    setScenario(sc)
    api.getEnterprise(sc.enterpriseID).then(ent => {
      setEnterprise(ent)
    })
    api.getEntitiesByParent(currentUser.userID, 0).then(e => {
      setEntities(e)
    })
    api.getFieldConfigItems(alt.scenarioID).then(fci => {
      setFieldConfigItems(fci)
    })
  }

  const loadGeneralDropdownData = scenarioId => {
    api.getScenarioList(scenarioId, "GovernanceBoard").then(g => {
      setGovernanceOptions(g)
    })
    api.getScenarioList(scenarioId, "SponsoringUnit").then(su => {
      setSponsoringOptions(su)
    })
    api.getList(currentUser.userID, "Priorities").then(pr => {
      setPriorityOptions(pr)
    })
  }

  const loadLabels = async s => {
    const sr = await api.getEnterpriseLabel(
      s.enterpriseID,
      "system retirements"
    )
    setSystemRetirementsLabel(sr)
    const gb = await api.getEnterpriseLabel(s.enterpriseID, "Governance Board")
    setGovernanceBoardLabel(gb)
    const sbu = await api.getEnterpriseLabel(
      s.enterpriseID,
      "Sponsoring business unit"
    )
    setSbuLabel(sbu)

    const pc = await api.getEnterpriseLabel(s.enterpriseID, "Planning Category")
    setPlanningCategoryLabel(pc)
    const lbr = await api.getEnterpriseLabel(
      s.enterpriseID,
      "Lead Business Representative"
    )
    setLbrLabel(lbr)
    const ic = await api.getEnterpriseLabel(
      s.enterpriseID,
      "Investment Category"
    )
    setInvestmentCategoryLabel(ic)

    const ap = await api.getEnterpriseLabel(s.enterpriseID, "Advanced Planning")
    setAdvancedPlanningLabel(ap)
    const brm = await api.getEnterpriseLabel(
      s.enterpriseID,
      "Business Relationship Manager"
    )
    setBrmLabel(brm)
    const ldo = await api.getEnterpriseLabel(
      s.enterpriseID,
      "Lead Delivery Organization"
    )
    setLdoLabel(ldo)
    const ps = await api.getEnterpriseLabel(s.enterpriseID, "Planning Stage")
    setPlanningStageLabel(ps)
  }

  const exportPageToPdf = () => {
    setIsExporting(true)
  }

  return (
    <Row
      style={{
        padding: "20px 50px",
        background: "white",
        backgroundColor: "white",
      }}
    >
      <Col>
        {alternative != null &&
          enterprise != null &&
          scenario != null &&
          fieldConfigItems.length > 0 &&
          tabs
            .filter(x => x.completed)
            .map((t, idx) => {
              if (t.listItemID == "General_Need") {
                return (
                  <div
                    className="mb-3"
                    style={{ pageBreakAfter: "always" }}
                    key={idx}
                  >
                    <GeneralNeedSectionViewOnly
                      alternative={alternative}
                      governanceOptions={governanceOptions}
                      sponsoringOptions={sponsoringOptions}
                      priorityOptions={priorityOptions}
                      fieldConfigItems={fieldConfigItems}
                      entities={entities}
                      formId={t.orderID}
                      sbuLabel={sbuLabel}
                      governanceBoardLabel={governanceBoardLabel}
                      enterprise={enterprise}
                    />
                  </div>
                )
              } else if (t.listItemID == "OCC_Approach") {
                return (
                  <div
                    className="mb-3"
                    style={{ pageBreakAfter: "always" }}
                    key={idx}
                  >
                    <OccApproachSectionViewOnly
                      alternative={alternative}
                      scenario={scenario}
                      sectionFormId={t.itemScore}
                      systemRetirementsLabel={systemRetirementsLabel}
                    />
                  </div>
                )
              }
              // else if (t.listItemID == "Contract") {
              //   return (
              //     <div
              //       className="mb-3"
              //       style={{ pageBreakAfter: "always" }}
              //       key={idx}
              //     >
              //       <h3>{t.listItemName} </h3>
              //       <ContractSectionViewOnly
              //         alternative={alternative}
              //         alternativeId={alternative.alternativeID}
              //         scenario={scenario}
              //         enterprise={enterprise}
              //       />
              //     </div>
              //   )
              // }
              // else if (t.listItemID == "Forecast") {
              //   return (
              //     <div
              //       className="mb-3"
              //       style={{ pageBreakAfter: "always" }}
              //       key={idx}
              //     >
              //       <h3>{t.listItemName} </h3>
              //       <ForecastSectionViewOnly
              //         alternative={alternative}
              //         alternativeId={alternative.alternativeID}
              //         scenario={scenario}
              //       />
              //     </div>
              //   )
              // }
              else if (t.listItemID == "Governance") {
                return (
                  <div
                    className="mb-3"
                    style={{ pageBreakAfter: "always" }}
                    key={idx}
                  >
                    <GovernanceSectionViewOnly
                      alternative={alternative}
                      alternativeId={alternative.alternativeID}
                      scenario={scenario}
                      fieldConfigItems={fieldConfigItems}
                      sectionFormId={t.itemScore}
                      brmLabel={brmLabel}
                      advancedPlanningLabel={advancedPlanningLabel}
                      investmentCategoryLabel={investmentCategoryLabel}
                      lbrLabel={lbrLabel}
                      planningCategoryLabel={planningCategoryLabel}
                      ldoLabel={ldoLabel}
                      planningStageLabel={planningStageLabel}
                    />
                  </div>
                )
              }
              // else if (t.listItemID == "Documents") {
              //   return (
              //     <div
              //       className="mb-3"
              //       style={{ pageBreakAfter: "always" }}
              //       key={idx}
              //     >
              //       <h3>{t.listItemName} </h3>
              //       <DocumentDrawer
              //         alternative={alternative}
              //         activeDrawer={"Document"}
              //         hideActionButtons={true}
              //       />
              //     </div>
              //   )
              // } else if (t.listItemID == "Notes") {
              //   return (
              //     <div
              //       className="mb-3"
              //       style={{ pageBreakAfter: "always" }}
              //       key={idx}
              //     >
              //       <h3>{t.listItemName} </h3>
              //       <NoteDrawer
              //         alternative={alternative}
              //         activeDrawer={"Notes"}
              //         hideActionButtons={true}
              //       />
              //     </div>
              //   )
              // }
              else if (t.listItemID == "Location") {
                return (
                  <div
                    className="mb-3"
                    style={{ pageBreakAfter: "always" }}
                    key={idx}
                  >
                    <LocationSection
                      enterprise={enterprise}
                      alternativeId={alternative.alternativeID}
                      scenarioId={alternative.scenarioID}
                      activeTab={"Location"}
                      sectionFormId={t.itemScore}
                      hideActionButtons={true}
                      // showToastChangesCallback={showToastChangesCallback}
                      // triggerFormSave={triggerDynamicFormSave}
                      // setTriggerFormSave={setTriggerDynamicFormSave}
                    />
                  </div>
                )
              }
              // else if (t.listItemID == "Lookback") {
              //   return (
              //     <div
              //       className="mb-3"
              //       style={{ pageBreakAfter: "always" }}
              //       key={idx}
              //     >
              //       <h3>{t.listItemName} </h3>
              //       <LookbackSection
              //         alternativeId={alternative.alternativeID}
              //         businessCaseID={alternative.businessCaseID}
              //         activeTab={"Lookback"}
              //         scenario={scenario}
              //         costChartId="costchart100"
              //         benefitChartId="benefitchart100"
              //         returnChartId="returnchart100"
              //         roiChartId="roichart100"
              //         irrChartId="irrchart100"
              //         paybackChartId="paybackchart100"
              //         timelineChartId="timelinechart100"
              //         hideActionButtons={true}
              //       />
              //     </div>
              //   )
              // } else if (t.listItemID == "Results") {
              //   return (
              //     <div
              //       className="mb-3"
              //       style={{ pageBreakAfter: "always" }}
              //       key={idx}
              //     >
              //       <h3>{t.listItemName} </h3>
              //       <ResultSection
              //         activeTab={"Results"}
              //         alternativeId={alternative.alternativeID}
              //         scenario={scenario}
              //         costBenefitChartId="costbenefitchart1000"
              //         costChartId="costchart1000"
              //         benefitChartId="benefitchart1000"
              //         returnChartId="returnchart1000"
              //         paybackChartId="paybackchart1000"
              //       />
              //     </div>
              //   )
              // }

              return null
            })}
      </Col>
    </Row>
  )
}

export default BusinessCaseReportPDFPage
